import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="custom-footer">
      <div className="container">
        {/* Top Section */}
        <div className="footer-top">
          {/* Column 1: Info */}
          <div className="footer-col info-col">
            <Link to="/" className="footer-logo">
              <img src="/images/logo1.png" alt="Miles Go Ride" />
            </Link>
            <p className="footer-desc">
              MILES GO RIDE is a trusted outstation cab service offering safe,
              comfortable, and affordable one-way and round-trip travel across
              Gujarat, with plans to expand pan-India soon.
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <i className="fab fa-whatsapp"></i> WhatsApp Only: 9723047222
              </div>
              <div className="contact-item">
                <i className="fab fa-whatsapp"></i> WhatsApp Only: 9723048222
              </div>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i> Ahmedabad, Gujarat,
                India
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i> support@milesgoride.com
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col links-col">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/about">
                  <i className="fas fa-caret-right"></i> About Us
                </Link>
              </li>
              <li>
                <Link to="/outstation-cabs">
                  <i className="fas fa-caret-right"></i> Outstation Cabs
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy">
                  <i className="fas fa-caret-right"></i> Privacy Policy
                </Link>
              </li>
              {/* <li>
                <Link to="/admin/login">
                  <i className="fas fa-caret-right"></i> Admin Login
                </Link>
              </li> */}
              <li>
                <Link to="/terms">
                  <i className="fas fa-caret-right"></i> Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/refund">
                  <i className="fas fa-caret-right"></i> Refund & Cancellation
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Support Center */}
          <div className="footer-col links-col">
            <h4 className="footer-title">Support Center</h4>
            <ul className="footer-links">
              <li>
                <Link to="/faq">
                  <i className="fas fa-caret-right"></i> FAQ's
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <i className="fas fa-caret-right"></i> Contact Us
                </Link>
              </li>
              <li>
                <Link to="/safety">
                  <i className="fas fa-caret-right"></i> Safety Guide
                </Link>
              </li>
              <li>
                <Link to="/passenger-guide">
                  <i className="fas fa-caret-right"></i> Passenger Guide
                </Link>
              </li>
              <li>
                <Link to="/captain-guide">
                  <i className="fas fa-caret-right"></i> Captain Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Promo image */}
          <div className="footer-col promo-col">
            <h3 className="promo-title">
              Miles to Go,
              <br />
              <span className="text-green">We'll Take Care.</span>
            </h3>
            <p className="promo-subtitle">
              Safe Rides. Trusted Captains.
              <br />
              Happy Journeys.
            </p>
            <div className="promo-image-wrapper">
              <img src="/images/testing.png" alt="Car" className="promo-car" />
            </div>
          </div>
        </div>

        {/* Features Highlights Section */}
        {/* <div className="footer-features">
          <div className="footer-feat-item">
            <div className="footer-feat-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <div className="footer-feat-text">
              <h5>Safe & Secure</h5>
              <p>
                Your safety is our
                <br />
                top priority.
              </p>
            </div>
          </div>
          <div className="footer-feat-item">
            <div className="footer-feat-icon">
              <i className="fas fa-clock"></i>
            </div>
            <div className="footer-feat-text">
              <h5>On Time Always</h5>
              <p>
                Punctual pickups
                <br />
                and drop-offs.
              </p>
            </div>
          </div>
          <div className="footer-feat-item">
            <div className="footer-feat-icon">
              <i className="fas fa-user-tie"></i>
            </div>
            <div className="footer-feat-text">
              <h5>Expert Captains</h5>
              <p>
                Verified, trained &<br />
                experienced drivers.
              </p>
            </div>
          </div>
          <div className="footer-feat-item">
            <div className="footer-feat-icon">
              <i className="fas fa-headset"></i>
            </div>
            <div className="footer-feat-text">
              <h5>24x7 Support</h5>
              <p>
                We're here for you
                <br />
                anytime, anywhere.
              </p>
            </div>
          </div>
          <div className="footer-feat-item">
            <div className="footer-feat-icon">
              <i className="fas fa-rupee-sign"></i>
            </div>
            <div className="footer-feat-text">
              <h5>Affordable Prices</h5>
              <p>
                Best prices for
                <br />
                best journeys.
              </p>
            </div>
          </div>
        </div> */}

        {/* Stats Section */}
        {/* <div className="footer-stats-container">
          <div className="stats-divider">
            <span className="line left"></span>
            <span className="text">TRUSTED BY THOUSANDS</span>
            <span className="line right"></span>
          </div>

          <div className="stats-content">
            <div className="stats-items">
              <div className="stat-item">
                <i className="fas fa-map-marker-alt"></i>
                <div className="stat-info">
                  <h4>150+</h4>
                  <p>Cities Covered</p>
                </div>
              </div>
              <div className="stat-item">
                <i className="fas fa-car"></i>
                <div className="stat-info">
                  <h4>5000+</h4>
                  <p>Rides Completed Daily</p>
                </div>
              </div>
              <div className="stat-item">
                <i className="fas fa-users"></i>
                <div className="stat-info">
                  <h4>10K+</h4>
                  <p>Happy Customers</p>
                </div>
              </div>
              <div className="stat-item">
                <i className="fas fa-shield-alt"></i>
                <div className="stat-info">
                  <h4>100%</h4>
                  <p>Safety & Reliability</p>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <i className="fas fa-quote-left quote-icon"></i>
              <p className="testimonial-text">
                Excellent service, on-time travel and very professional
                captains.
              </p>
              <div className="stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <span className="author">- Happy Customer</span>
              </div>
            </div>
          </div>
        </div> */}

        {/* Bottom Bar (Downloads, Socials, Payments) */}
        <div className="footer-bottom-bar">
          <div className="bottom-col">
            <h5>Download Apps</h5>
            <div
              className="app-buttons"
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <a
                href="/apks/MilesGoRide-User.apk"
                download
                className="btn"
                style={{
                  backgroundColor: "#49ba09",
                  color: "#fff",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "8px 15px",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  textDecoration: "none",
                  border: "none",
                }}
              >
                <i className="fas fa-user"></i> MGR USER
              </a>
              <a
                href="/apks/MilesGoRide-Captain.apk"
                download
                className="btn"
                style={{
                  backgroundColor: "#49ba09",
                  color: "#fff",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "8px 15px",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  textDecoration: "none",
                  border: "none",
                }}
              >
                <i className="fas fa-car"></i> MGR CAPTAIN
              </a>
            </div>
          </div>
          <div className="bottom-col">
            <h5>Follow Us On</h5>
            <div className="social-links">
              <a
                href="https://www.facebook.com/share/15mejQrS1C/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon fb"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/milesgoride/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon ig"
              >
                <i className="fab fa-instagram"></i>
              </a>
              {/* <a href="#" className="social-icon tw">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-icon in">
                <i className="fab fa-linkedin-in"></i>
              </a> */}
            </div>
          </div>
          <div className="bottom-col">
            <h5>We Accept</h5>
            <div className="payment-icons">
              {/* <div className="payment-badge"><img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png" alt="Visa" /></div> */}
              <div className="payment-badge">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
                  alt="Mastercard"
                />
              </div>
              <div className="payment-badge">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/e/e1/UPI-Logo-vector.svg"
                  alt="UPI"
                />
              </div>
              <div className="payment-badge">
                <img
                  src="https://download.logo.wine/logo/PhonePe/PhonePe-Logo.wine.png"
                  alt="PhonePe"
                />
              </div>
              <div className="payment-badge">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg"
                  alt="GPay"
                />
              </div>
            </div>
          </div>
          <div className="bottom-col secure-badge">
            <i className="fas fa-lock"></i>
            <div>
              <strong>100% SECURE</strong>
              <p>Your data is safe and protected</p>
            </div>
          </div>
        </div>

        {/* Copyright line */}
        <div className="footer-copyright">
          <p>
            © 2026 MilesGoRide. All rights reserved.{" "}
            <span className="separator">|</span> Made with{" "}
            <i className="fas fa-heart text-green"></i> in India
          </p>
          <div
            style={{
              marginTop: "12px",
              fontSize: "13px",
              color: "#a3a8b0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              flexWrap: "wrap",
              padding: "8px 16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "30px",
              display: "inline-flex",
            }}
          >
            <span>
              <i
                className="fas fa-code"
                style={{ color: "#49ba09", marginRight: "6px" }}
              ></i>{" "}
              Developed by{" "}
              <strong style={{ color: "#e0e0e0" }}>Harsh Shukal</strong>
            </span>
            <span style={{ color: "#49ba09", opacity: 0.5 }}>|</span>
            <a
              href="tel:+919714874318"
              style={{
                color: "#a3a8b0",
                textDecoration: "none",
                transition: "color 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.color = "#49ba09")}
              onMouseOut={(e) => (e.target.style.color = "#a3a8b0")}
            >
              <i
                className="fas fa-phone-alt"
                style={{ color: "#49ba09", marginRight: "6px" }}
              ></i>{" "}
              +91 97148 74318
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
